import { durationDisplay } from "components/SoundClipEditor/Controls/Player";

type DurationProps = {
    ms?: number;
    seconds?: number;
};

export function Duration(props: DurationProps) {
    // Compare against null so a zero duration renders as 00:00 rather than
    // falling through to null the way a missing value does.
    if (props.ms != null) return durationDisplay(props.ms / 1000);
    else if (props.seconds != null) return durationDisplay(props.seconds);
    else return null;
}
